import useComposer from './useComposer';

const useMultiComposer = () => {
  const result = useComposer();

  return result;
};

export default useMultiComposer;
